<template>
  <div class="picture">
    <img :src="element.style.url || picture" alt="" @load="onLoad" />
  </div>
</template>

<script>
import OnEvent from '../common/OnEvent.vue'

export default {
  extends: OnEvent,
  props: {
    propValue: {
      type: Object,
      required: true,
      default: () => {}
    },
    element: {
      type: Object,
      default: () => {}
    },
    pictureType: {
      type: Number,
      default: 1
    }

  },
  data() {
    return {
      picture: require('../../../../../../../assets/images/custom-screen/picture.png'),
      isFirst: false
    }
  },

  mounted() {
    if (this.element.style.url) {
      this.isFirst = true
    }
  },
  methods: {
    onLoad(e) {
      if (this.isFirst) {
        this.isFirst = false
        return
      }
      if (this.pictureType !== 1) {
        return
      }
      var img = new Image()
      const _this = this
      img.onload = function() {
        // 获取原宽高
        _this.$set(_this.element.style, 'width', img.naturalWidth)
        _this.$set(_this.element.style, 'height', img.naturalHeight)
      }
      img.src = this.element.style.url
    }
  }
}
</script>
<style scoped>
.picture img{
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
</style>
